<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select class="selScale" v-model="filter.dev_type">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="台区" value="power_transformer"> </el-option>
          <el-option label="一体柜" value="power_cabinet"> </el-option>
          <el-option label="分支箱" value="power_branch_box"> </el-option>
          <el-option label="充电桩" value="power_charge_pile"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="资产码" prop="asset_code" width="220" align="center">
        <template slot-scope="{ row }">
          <div class="show_assets_code" @click="showTripletDetail(row.asset_code)">{{ row.asset_code }}</div>
        </template>
      </el-table-column>
      <el-table-column label="设备名称" prop="re_dev_name" align="center"></el-table-column>
      <el-table-column label="设备类型" prop="re_dev_type" align="center" width="180px"></el-table-column>
      <el-table-column label="状态" prop="status_name" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.status == 1">在线</el-tag>
          <el-tag type="info" v-else>离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="功率(kW)" prop="cur_power" width="100" align="center"></el-table-column>

      <el-table-column label="备注" prop="breakerInfo" width="100" align="center" show-overflow-tooltip></el-table-column>

      <el-table-column label="在线时间" prop="last_time" width="190" align="center"></el-table-column>
      <el-table-column label="投运时间" prop="create_time" width="190" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="200px" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
          <el-button type="text" v-if="row.status == 1" @click="onDevRestart(row)" v-permision_tjtf="'dev_restart'">设备重启</el-button>
          <el-button type="text" @click="editPowerCurve(row)" v-permision_tjtf="'gl_quxian'">功率曲线</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 设备状态详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" title="设备状态详情" width="1300px" :close-on-click-modal="false" class="detail-dialog lower_formitem_box">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm" style="padding: 0px 30px">
            <!-- 1. 档案信息（triplet） -->
            <h3>档案信息 ——{{ detailForm.re_dev_type }}——{{ detailForm.re_dev_name }}</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="资产码" prop="assetsCode">
                  <el-input v-model="detailForm.triplet.assetsCode" readonly disabled />
                </el-form-item>
                <el-form-item label="出厂编码" prop="FactoryCode">
                  <el-input v-model="detailForm.triplet.FactoryCode" readonly disabled />
                </el-form-item>

                <el-form-item label="公钥" prop="PublickKey">
                  <el-input v-model="detailForm.triplet.PublickKey" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="私钥" prop="SecrtKey">
                  <el-input v-model="detailForm.triplet.SecrtKey" readonly disabled />
                </el-form-item>
                <el-form-item label="注册码" prop="RegCode">
                  <el-input v-model="detailForm.triplet.RegCode" readonly disabled />
                </el-form-item>
                <el-form-item label="类型名称" prop="TypeName">
                  <el-input v-model="detailForm.triplet.TypeName" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态" prop="State">
                  <!-- <el-input :value="detailForm.triplet ? (detailForm.triplet.State == 1 ? '在线': '离线') : ''" readonly disabled /> -->
                   <el-input :value="detailForm.triplet.State ? detailForm.status_name : ''" readonly disabled />
                </el-form-item>
                <el-form-item label="创建时间" prop="CreateTime">
                  <el-input v-model="detailForm.triplet.CreateTime" readonly disabled />
                </el-form-item>
                <el-form-item label="" prop="triplet_id">
                  <el-button type="primary" v-permision_tjtf="'call_offline_order'" v-if="detailForm.status == 1 && detailForm.re_dev_type == '分支箱'" @click="onCallOfflineOrder(detailForm)">招离线订单</el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 2. 设备信号强度数据（acDeRealIty） -->
            <h3>信号强度</h3>
            <el-row :gutter="20" v-if="detailForm.acDeRealIty">
              <el-col :span="8">
                <el-form-item label="机箱温度" prop="caseTemp">
                  <el-input v-model="detailForm.acDeRealIty.caseTemp" readonly disabled />
                </el-form-item>

                <el-form-item label="网络ID" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.netId" readonly disabled />
                </el-form-item>
                <el-form-item label="采集时间" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.create_time" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="网络类型" prop="netType">
                  <el-input :value="formatNetType(detailForm.acDeRealIty.netType)" readonly disabled />
                </el-form-item>
                <el-form-item label="loraMac" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.loraMac" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="信号值" prop="sigVal">
                  <el-input v-model="detailForm.acDeRealIty.sigVal" readonly disabled />
                </el-form-item>
                <el-form-item label="loraRssi" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.loraRssi" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>

            <!-- 3. 设备版本信息（verinfo_evt） -->
            <h3>设备版本</h3>
            <el-row :gutter="20" v-if="detailForm.verinfo_evt">
              <el-col :span="8">
                <el-form-item label="SDK版本" prop="sdkVer">
                  <el-input v-model="detailForm.verinfo_evt.sdkVer" readonly disabled />
                </el-form-item>

                <el-form-item label="采集时间" prop="sdkVer">
                  <el-input v-model="detailForm.verinfo_evt.create_time" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="硬件版本" prop="pileHardwareVer">
                  <el-input v-model="detailForm.verinfo_evt.pileHardwareVer" readonly disabled />
                </el-form-item>
                <el-form-item label="软件版本" prop="pileSoftwareVer">
                  <el-input v-model="detailForm.verinfo_evt.pileSoftwareVer" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="设备注册方式" prop="devRegMethod">
                  <el-input :value="formatDevRegMethod(detailForm.verinfo_evt.devRegMethod)" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>
            <!-- 4. 设备固件信息（firmware_evt） -->
            <h3>设备固件</h3>
            <el-row :gutter="20" v-if="detailForm.firmware_evt">
              <el-col :span="8">
                <el-form-item label="CT" prop="firmware_evt_CT">
                  <el-input v-model="detailForm.firmware_evt.CT" readonly disabled />
                </el-form-item>
                <el-form-item label="计量类型" prop="meaType">
                  <el-input v-model="detailForm.firmware_evt.meaType" readonly disabled />
                </el-form-item>
                <el-form-item label="蓝牙MAC" prop="btMac">
                  <el-input v-model="detailForm.firmware_evt.btMac" readonly disabled />
                </el-form-item>
                <el-form-item label="设备序列号" prop="devSn">
                  <el-input v-model="detailForm.firmware_evt.devSn" readonly disabled />
                </el-form-item>
                <el-form-item label="设备类型" prop="devType">
                  <el-input v-model="detailForm.firmware_evt.devType" readonly disabled />
                </el-form-item>

                <el-form-item label="电网类型" prop="gridType">
                  <el-input v-model="detailForm.firmware_evt.gridType" readonly disabled />
                </el-form-item>
                <el-form-item label="采集时间" prop="gridType">
                  <el-input v-model="detailForm.firmware_evt.create_time" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="输出电流" prop="otCur">
                  <el-input v-model="detailForm.firmware_evt.otCur" readonly disabled />
                </el-form-item>
                <el-form-item label="最大输出电压" prop="otMaxVol">
                  <el-input v-model="detailForm.firmware_evt.otMaxVol" readonly disabled />
                </el-form-item>
                <el-form-item label="最小输出电压" prop="otMinVol">
                  <el-input v-model="detailForm.firmware_evt.otMinVol" readonly disabled />
                </el-form-item>
                <el-form-item label="输出功率" prop="otRate">
                  <el-input v-model="detailForm.firmware_evt.otRate" readonly disabled />
                </el-form-item>
                <el-form-item label="端口数量" prop="portNum">
                  <el-input v-model="detailForm.firmware_evt.portNum" readonly disabled />
                </el-form-item>
                <el-form-item label="SIM卡MAC" prop="simMac">
                  <el-input v-model="detailForm.firmware_evt.simMac" readonly disabled />
                </el-form-item>
                <el-form-item label="" prop="simMac">
                  <el-button type="primary" v-permision_tjtf="'send_query_sim'" @click="onSendQuerySim(detailForm)"> 查询sim</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电表地址" prop="outMeter_db">
                  <el-input v-model="detailForm.firmware_evt.outMeter_db" readonly disabled />
                </el-form-item>
                <el-form-item label="门锁状态" prop="isGateLock">
                  <el-input :value="formatGateLockStatus(detailForm.firmware_evt.isGateLock)" readonly disabled />
                </el-form-item>
                <el-form-item label="地锁状态" prop="isGroundLock">
                  <el-input :value="formatGroundLockStatus(detailForm.firmware_evt.isGroundLock)" readonly disabled />
                </el-form-item>
                <el-form-item label="桩型号" prop="stakeModel">
                  <el-input v-model="detailForm.firmware_evt.stakeModel" readonly disabled />
                </el-form-item>
                <el-form-item label="厂商代码" prop="vendorCode">
                  <el-input v-model="detailForm.firmware_evt.vendorCode" readonly disabled />
                </el-form-item>
                <el-form-item label="SIM卡号" prop="simNo">
                  <el-input v-model="detailForm.firmware_evt.simNo" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>
            <!-- 5. 设备类型信息 -->
            <h3>设备类型信息</h3>
            <el-row :gutter="20" v-if="detailForm.dev_inform_evt">
              <el-col :span="8">
                <el-form-item label="资产码" prop="dev_inform_evt_asset_code">
                  <el-input v-model="detailForm.dev_inform_evt.asset_code" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="版本" prop="dev_inform_evt_version">
                  <el-input v-model="detailForm.dev_inform_evt.version" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="采集时间" prop="dev_inform_evt_version">
                  <el-input v-model="detailForm.dev_inform_evt.create_time" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>
            <el-form-item label="断路器状态" prop="dev_inform_evt_asset_code">
              <el-input v-model="breakerInfoDetail" readonly disabled />
            </el-form-item>

            <!-- 6. 最近升级信息 -->
            <h3 style="margin-top: 20px;">最近升级信息</h3>
            <el-row :gutter="20" v-if="detailForm.last_upgrade">
              <el-col :span="10">
                <el-form-item label="版本" >
                  <el-input v-model="detailForm.last_upgrade.version" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="升级时间" >
                  <el-input v-model="detailForm.last_upgrade.create_time" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>

          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 功率曲线组件 -->
    <power-curve :show.sync="visible.curve" :params="modelParams" @confirm="confirmpowercurve" class="detail-dialog"></power-curve>
    <power-order-curve :show.sync="visible.ordercurve" :params="modelParams" @confirm="confirmpowercurve" class="detail-dialog"></power-order-curve>
    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getOnlinePageList, GetDevExtInfo } from "@/api/dev_archive"
import { Send_DevRestart, Send_QuerySim, Send_BranchBox_CallOfflineOrder } from "@/api/dev_send_order"
import powercurve from "./components/power-curve.vue"
import powerordercurve from "./components/power-order-curve.vue"
import tripletDetail from "../control/_triplet_detail.vue"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: {
    "power-order-curve": powerordercurve,
    "power-curve": powercurve,
    fileUpload,
    tripletDetail
  },
  data() {
    return {
      tableData: [],
      visible: {
        curve: false,
        ordercurve: false
      },
      filter: {
        assets_code: "",
        dev_type: ""
      },
      loading: false,
      isUpdate: true,
      gid: "",
      detailVisible: false,
      modelParams: {},
      breakerInfoDetail: "",
      detailForm: {
        // 基本档案信息
        ID: "",
        triplet: {},
        firmware_evt: {},
        acDeRealIty: {},
        verinfo_evt: {},
        dev_inform_evt: {},
        status: 0,
        re_dev_type: "",
        status_name: '',
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    onCallOfflineOrder(data) {
      Send_BranchBox_CallOfflineOrder({ triplet_id: data.triplet_id }).then((res) => {
        this.$message.success(res.msg)
      })
    },
    // 格式化网络类型（10-17）
    formatNetType(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "获取不到网络类型",
        11: "2G",
        12: "3G",
        13: "4G",
        14: "5G",
        15: "NB-IOT",
        16: "WIFI",
        17: "有线网络"
      }
      const key = String(value)
      return map[key] || value
    },
    // 格式化设备注册方式（10-16）
    formatDevRegMethod(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "屏幕",
        11: "蓝牙",
        12: "串口",
        13: "NFC",
        14: "USB 外设",
        15: "固件",
        16: "其他"
      }
      const key = String(value)
      return map[key] || value
    },
    // 格式化门锁状态（10:解锁, 11:上锁）
    formatGateLockStatus(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "解锁",
        11: "上锁"
      }
      const key = String(value)
      return map[key] || value
    },
    // 格式化地锁状态（10:解锁状态, 11:上锁状态）
    formatGroundLockStatus(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "解锁",
        11: "上锁"
      }
      const key = String(value)
      return map[key] || value
    },
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },

    onDevRestart(row) {
      Send_DevRestart({ triplet_id: row.triplet_id }).then((res) => {
        this.$message.success(res.msg)
      })
    },

    // 打开详情弹窗
    async onDetail(row) {
      this.breakerInfoDetail = row.breakerInfoDetail
      this.detailVisible = true
      this.loading = true
      // 调用GetDevExtInfo接口获取详细数据
      const res = await GetDevExtInfo({
        asset_code: row.asset_code
      })
      this.loading = false
      //console.log(`详情数据：`,res)
      if (res) {
        const data = res;
        this.detailForm = data;
        this.detailForm.triplet = data.triplet || {};
        this.detailForm.firmware_evt = data.firmware_evt || {};
        this.detailForm.verinfo_evt = data.verinfo_evt || {};
        this.detailForm.dev_inform_evt = data.dev_inform_evt || {};
        this.detailForm.acDeRealIty = data.acDeRealIty || {};
        this.detailForm.last_upgrade = data.last_upgrade || {};
        this.detailForm.status = row.status;
        this.detailForm.status_name = row.status_name;

        this.detailForm.re_dev_type = row.re_dev_type;
        this.detailForm.re_dev_name = row.re_dev_name;

        this.detailForm.triplet_id = row.triplet_id;
      }
    },

    editPowerCurve(row) {
      this.modelParams = {
        asset_code: row.asset_code,
        re_dev_name: row.re_dev_name,
        re_dev_type: row.re_dev_type,
        status_name: row.status_name
      }
      if (row.re_dev_type == "充电桩") {
        this.visible.ordercurve = true
      } else {
        this.visible.curve = true
      }
    },

    confirmpowercurve(item) {
      this.visible.curve = false
      this.detailForm.asset_code = item.asset_code
    },

    getData() {
      this.loading = true
      getOnlinePageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        dev_type: this.filter.dev_type || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSendQuerySim(row) {
      this.loading = true
      Send_QuerySim({ triplet_id: row.triplet.ID }).then((res) => {
        this.$message.success(res.msg)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.my-pagination {
  margin-top: 20px;
  text-align: right;
}
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 去除详情对话框的内外边距 */
.detail-dialog ::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* 确保表格容器没有额外间距 */
.my-pagination {
  margin-top: 20px;
  text-align: right;
}
.zanwu {
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
</style>
